export default "__VITE_ASSET__8cf80312__"